import React, { useEffect, useState } from 'react';
import { Button, Divider, Drawer, Form, Input, InputNumber, message, Row, Select, Tooltip } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import FireFetch from "../../Firebase/FireFetch";
import { Checkbox } from "evergreen-ui";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import Firebase from "../../Firebase/Firebase";
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";


const { TextArea } = Input;
var db = getDatabase(Firebase);
const AddQuestion = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateSurvey = canAccessModule("SURVEYS", "create");
	const [questions] = useListVals(ref(db, `talmidsdb/surveys/${props.surveyID}/questions`));
	const [questionArray, setQuestionArray] = useState([]);
	const [addModal, setAddModal] = useState(props.modal);
	const [count, setCount] = useState(0);
	const [questionForm] = Form.useForm();
	const [answerType, setAnswerType] = useState("");

	useEffect(() => {
		setAddModal(props.modal);
		var tempArray = [];
		if (questions) {
			tempArray = questions.filter(x => x.surveyID === props.surveyID);
			setQuestionArray([...tempArray]);
		}
	}, [props, questions]);

	const handleAnswerType = (option) => {
		console.log(option);
		setAnswerType(option);
	}

	const addQuestion = (values) => {
		if (!canCreateSurvey) {
			message.error("You do not have permission to create survey questions.");
			return;
		}

		var questionIndex = questionArray.length;

		var questionID = Array(10).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz")
			.map(function (x) { return x[Math.floor(Math.random() * x.length)] }).join('');

		var questionObject = values;
		if (String(questionObject.answerType || "").includes("Multiple Choice") && !questionObject.choiceOptions?.length) {
			message.error("Please add at least one multiple choice option.");
			return;
		}
		questionObject.surveyID = props.surveyID;
		questionObject.questionIndex = questionIndex;
		questionObject.questionID = questionID;
		questionObject.timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");

		Object.entries(questionObject).forEach(([key, value]) => {
			if (value === undefined) {
				questionObject[key] = "";
			}
		});

		const output = FireFetch.SaveTODB(`surveys/${props.surveyID}/questions`, questionID, questionObject);
		output.then((result) => {
			if (result === "success") {
				FireFetch.addLog("surveys", questionID, "Create");
				message.success("Question created successfully");
				questionForm.resetFields();
				setCount(0);
			} else {
				message.error("Unable to create Question");
			}
		});
	}
	return (
		<>
			<Drawer
				title="Add Question"
				width={500}
				placement="right"
				onClose={() => { props.setModal(false) }}
				visible={addModal}
				footer={
					<>
						<Button id="btnSubmit" form="questionForm" type="primary" htmlType="submit" className="mb-3" disabled={!canCreateSurvey}>
							Add Question
						</Button>
					</>
				}
				className="font-Nunito"
			>
				{
					<Form
						layout="vertical"
						id={"questionForm"}
						form={questionForm}
						onFinish={addQuestion}
					>
						<Form.Item label="Question"
							name="question"
							rules={[{ required: true }]}
						>
							<TextArea placeholder={"enter question"} id={"AddedQ"} />
						</Form.Item>
						<Form.Item label="Answer Type"
							name="answerType"
							rules={[{ required: true }]}
						>
							<Select placeholder="Select answerType"
								showSearch
								optionFilterProp="children"
								filterOption={filterSelectOption}
								filterSort={sortSelectOptions} onChange={handleAnswerType}>
								{["Yes/No", "Multiple Choice",
									"Linear Scale", "Long answer", "Short answer"]
									.map((item, index) => (
										<Select.Option key={index} value={item}>{item}</Select.Option>
									))}

							</Select>
						</Form.Item>

						{answerType === "Yes/No" ?

							<>
								<Form.Item name="maybeOption" valuePropName="checked">
									<Checkbox
										label={<p className="font-Nunito">Add Maybe Option</p>}
									/>
								</Form.Item>
							</>
							:
							null
						}

						{answerType === "Linear Scale" ?
							<>
								<p>Select scale minimum and maximum</p>
								<Row>
									<Form.Item name="min">
										<InputNumber min={1} max={10} className="mr-2" placeholder="min" />
									</Form.Item>
									<Form.Item name="max">
										<InputNumber min={1} max={10} className="mr-2" placeholder="max" />
									</Form.Item>
								</Row>
								<Form.Item label="Minimum Label"
									name="minLabel">
									<Input placeholder="minimum label" />
								</Form.Item>
								<Form.Item label="Maximum Label"
									name="maxLabel">
									<Input placeholder="maximum label" />
								</Form.Item>

							</>
							:
							null
						}

						{answerType.includes("Multiple Choice") ?

							<Form.List name="choiceOptions">
								{(fields, { add, remove }) => {
									return (
										<div>
											{fields.map((field, index) => (
												<Form.Item
													label={index === 0 ? 'Options' : ''}
													required={false}
													key={field.key}
												>
													<Form.Item
														{...field}
														validateTrigger={['onChange', 'onBlur']}
														rules={[
															{
																required: true,
																whitespace: true,
																message: "Please input option text",
															},
														]}
														noStyle
													>
														<Input
															placeholder="enter option text"
															style={{
																width: '75%',
															}}
														/>
													</Form.Item>
													{fields.length > 0 ? (
														<Tooltip title="Remove option">
															<Button type="danger"
																shape="circle"
																icon={<MinusCircleOutlined />}
																className="dynamic-delete-button mx-2"
																onClick={() => {
																	setCount(count - 1);
																	remove(field.name);
																}} />
														</Tooltip>


													) : null}
												</Form.Item>
											))}
											<Divider />
											<Form.Item>
												<Button
													type="dashed"
													onClick={() => {
														setCount(count + 1);
														add();
													}}
													style={{ width: "40%" }}
												>
													<PlusOutlined /> Add Option
												</Button>
											</Form.Item>
										</div>
									);
								}}
							</Form.List>

							:
							null
						}


					</Form>

				}


			</Drawer>
		</>
	)
}

export default AddQuestion;
